import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Vendor_Table_Head } from "../../../components/datagrid/assetmanagement/VendorTableHead";
import Addvendor from "./Addvendor";
import UpdateVendor from "./UpdateVendor";
import DeleteVendor from "./DeleteVendor";
import { getAllVendors } from "../../../redux/features/assetManagementSlice";

const VendorList = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, vendorData } = useSelector((state) => state.assetmanagement);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    filter: search,
  };

  useEffect(() => {
    dispatch(getAllVendors(data));
  }, [pageNum, gridSize, search]);

  return (
    <GlobalWrapper
      title={"Vendors"}
      actions={<Addvendor dispatchParams={data} />}
    >
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Vendor_Table_Head}
          rows={vendorData.data}
          meta={vendorData?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.name} />
              <GlobalAnchorList
                label=""
                component={
                  <UpdateVendor rowData={rowData} dispatchParams={data} />
                }
              />
              <GlobalAnchorList
                label=""
                component={<DeleteVendor id={rowData?.vendorID} data={data} />}
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default VendorList;
